export default __webpack_public_path__ + "../img/e33cdafaa5ff92091f66f1de93d77bb5.png";